import { OrganizationTraits } from '@neptune/shared/core-organizations-domain';

export const hasPlansToUpgrade = ({ planUpgrade }: OrganizationTraits): boolean => {
  if (planUpgrade == null) {
    return false;
  }

  return planUpgrade.availablePlans.length > 0;
};
